import { SIGN_OUT, SIGN_IN } from "../globals/events.js"
import { showElements } from "../shared/util.js"
import { registerClickHandlers } from "./newGameForm.js"
import { getGameInvites } from "./pendingGames.js"

function init() {
  document.addEventListener(SIGN_IN, handleSignIn);
  document.addEventListener(SIGN_OUT, handleSignOut);
  if (window.ID.user) {
    handleSignIn();
  }

  registerClickHandlers();
}

function handleSignIn(e) {
  showElements({
    "signed-out": false,
    "signed-in": true,
  })
  const user = window.ID.user;
  const profile = user.getBasicProfile();
  document.getElementById("name").innerText = profile.getName();
  
  getGameInvites();
}

function handleSignOut(e) {
  showElements({
    "signed-out": true,
    "signed-in": false,
  })
  document.getElementById("name").innerText = "";
}

init();